<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">角色管理·数据表格</h5>
        </a-col>
      </a-row>
    </template>
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <a-form-item label="角色名称">
            <a-input v-model="dataForm.role_name" placeholder="角色名称" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增角色</a-button>
          </a-form-item>
        </a-form>

        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="id" :loading="dataListLoading">
          <template slot="department.department_name" slot-scope="department_name">
            <a-tag>{{ department_name }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.id)">
              编辑
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.id)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/role/page",
        deleteURL: "/admin/role/delete",
      },
      dataForm: {
        role_name: "",
        department_id: undefined,
      },
      columns: [
        {
          title: "角色名称",
          dataIndex: "role_name",
          width: 200
        },
        {
          title: "数据权限",
          dataIndex: "role_type",
          width: 200,
          customRender: (text) => text == 1  ? '本部门及以下' : text == 3  ? '仅看自己' : ''
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 300
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 300
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 300,
          fixed: "right",
        },
      ],
    };
  },
  methods: {},
};
</script>